import TextField from "@mui/material/TextField";
import { Fragment } from "react";
import { Controller } from "react-hook-form"
import Typography from "@mui/material/Typography";
import FormHelperText from '@mui/material/FormHelperText';

const MpgPsudoInput = ({ rhfFormInstance, name, className, label, fullWidth, sx, onExtraOnchangeHandler, labelStyleSx }) => {

    const { control, formState } = rhfFormInstance

    const myStyle = {
        maxWidth: !!fullWidth ? fullWidth : '225px',
        display: 'none'
    }
    const myLabelStyle = {
        color: "#8991a0",
        textAlign: 'left'
    };

    return (
        <Controller
            control={control}
            name={name}
            render={({
                field: { onChange, onBlur, value, ref },
                fieldState: { invalid, isTouched, isDirty, error },
                formState: { errors },
            }) => {
                return (
                    <Fragment>
                        <Typography sx={[myLabelStyle, labelStyleSx]}>
                            {label}
                        </Typography>
                        <TextField
                            id={`${name}-mpg-input`}
                            className={!!className ? className : ''}
                            name={`${name}`}
                            onChange={(e) => {
                                onChange(e)

                                if (!!onExtraOnchangeHandler) {
                                    onExtraOnchangeHandler(e)
                                }
                            }}

                            value={value}
                            inputRef={ref}

                            defaultValue=""

                            label={label}
                            sx={[myStyle, sx]}
                            margin="normal"

                        // hidden/**imp for psudoInput */
                        />
                        <FormHelperText error={!!errors[name]}>{!!error && error.message}</FormHelperText>
                    </Fragment>
                )
            }}
        />
    )
}
export default MpgPsudoInput